module.exports = __webpack_public_path__ + "static/media/img-guidebook-img02.b53cffb8.png";